import Vue from "vue";
import Component from "vue-class-component";
import { CarouselDirection } from "@/components/Util/Layout/Carousel/CarouselInterface";

@Component({
  name: "CarouselItem",
})
export default class CarouselItem extends Vue {
  cx_start_drag?: DragEvent | undefined;
  cx_stop_drag?: DragEvent | undefined;

  mounted(): void {
    const el: HTMLElement = this.$refs.item as HTMLElement;

    el.childNodes.forEach((child: ChildNode) => {
      const c = child as HTMLElement;
      c.addEventListener("dragstart", this.hideGhostOnDrag);
    });
  }

  unmounted(): void {
    const el: HTMLElement = this.$refs.item as HTMLElement;

    el.childNodes.forEach((child: ChildNode) => {
      const c = child as HTMLElement;
      c.removeEventListener("dragstart", this.hideGhostOnDrag);
    });
  }

  hideGhostOnDrag(event: DragEvent): void {
    event?.dataTransfer?.setDragImage(
      document.getElementById("drag-drop-none-image") as HTMLImageElement,
      0,
      0
    );
  }

  calculeDirection(start: DragEvent, end: DragEvent): CarouselDirection {
    const horizontal: number = start.x - end.x;
    const vertical: number = start.y - end.y;

    if (Math.abs(horizontal) > Math.abs(vertical))
      return horizontal > 0 ? CarouselDirection.RIGHT : CarouselDirection.LEFT;

    return vertical > 0 ? CarouselDirection.UP : CarouselDirection.DOWN;
  }

  onDrag(event: any): void {
    this.$emit("onDrag", event);
    this.$parent.$emit("onDrag", event);
  }

  onDragEnter(event: any): void {
    this.$emit("onDragEnter", event);
    this.$parent.$emit("onDragEnter", event);
  }

  onDragOver(event: any): void {
    this.$emit("onDragOver", event);
    this.$parent.$emit("onDragOver", event);
  }

  onDragLeave(event: any): void {
    this.$emit("onDragLeave", event);
    this.$parent.$emit("onDragLeave", event);
  }

  onDragStart(event: any): void {
    this.cx_start_drag = event;

    this.$emit("onDragStart", event);
    this.$parent.$emit("onDragStart", event);
  }

  onDragEnd(event: any): void {
    if (event && this.cx_start_drag) {
      const direction: CarouselDirection = this.calculeDirection(this.cx_start_drag, event);
      const data: any = { direction };

      this.$emit("onDragEnd", data);
      this.$parent.$emit("onDragEnd", data);
    }
  }
}
